/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IEveUserRolesViewProps } from './eve-user-roles';

export default (props: IEveUserRolesViewProps) => {
    return <div className='row'></div>;
};
